/* eslint-disable no-underscore-dangle */
import CustomListView from 'src/components/customTable/CustomListView';
import { useCallback, useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Grid, Button, Container, Box, Tab, Tabs } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import useSettings from 'src/hooks/useSettings';
import setTitle from 'src/utils/setTitle';
import RestartAltIcon from '@material-ui/icons/RestartAlt';
import { useParams } from 'react-router';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import { pimApis } from 'src/api/pim';
import { TextField } from '@mui/material';
import { debounce } from 'lodash';
import toast from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ProductDialog from './ProductDialog';
import HistoryIcon from '@material-ui/icons/History';
import ProductHistoryDialog from './ProductHistoryDialog';
import ProductDrawer from './components/productDrawer';
import FileUpload from 'src/components/FileUpload';
import { Background } from 'reactflow';


const useStyles = makeStyles<Theme>(() =>
  createStyles({
    activeButton: {
      background: 'rgba(7, 83, 0, 0.1)',
      color: 'rgba(29, 122, 21, 1)',
      width: '60px',
      fontSize: '12px',
      '&:hover': {
        // Disable hover effect
        background: 'rgba(7, 83, 0, 0.1)',
        color: 'rgba(29, 122, 21, 1)',
      },
    },
    productsTable: {
      '& .MuiTable-root': {
        tableLayout: 'auto !important',
      },
      '& th': {
        textTransform: 'capitalize',

      },
    },
    inActiveButton: {
      background: 'rgba(255, 161, 161, 0.3)',
      color: 'red',
      width: '60px',
      fontSize: '12px',
      '&:hover': {
        // Disable hover effect
        background: 'rgba(255, 161, 161, 0.3)',
        color: 'red',
      },
    },
    tabs: {
      '& .MuiTab-root': {
        backgroundColor: 'transparent',
        borderRadius: '4px',
        minWidth: '120px',
        minHeight: '30px',
      },
      '& .MuiTabs-indicator': {
        bottom: '6px',
      },
      '& .Mui-selected': {
        backgroundColor: '#231F20',
        color: '#fff',
      },
    },
  })
);
const CategoriesProduct = () => {
  setTitle('ERP | Product Information Management');
  const classes = useStyles();
  const categoryName = localStorage.getItem('categoryName'); // Retrieve from local storage
  const catalogueName = localStorage.getItem('catalogueName'); // Retrieve from local storage

  const { catalogueId, categoryId, productTemplateId } = useParams();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [addProduct, setAddProduct] = useState(false);
  const [editProduct, setEditProduct] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [productData, setProductData] = useState([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [activeTab, setActiveTab] = useState('all');
  const [uploadFile, setUploadFile] = useState(false);


  const [page, setPage] = useState<any>(0);
  const [pageSize, setPageSize] = useState<any>(25);
  const [search, setSearch] = useState<string>('');
  const [selectedSort, setSelectedSort] = useState<any>({
    id: '',
    value: 'asc',
  });

  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [customColumns, setCustomColumns] = useState<any>([]);
  const [productFields, setProductFields] = useState<any>([]);

  const saerchRef = useRef(null);

  const [dialogInitialValues, setDialogInitialValues] = useState({
    name: '',
    description: '',
    productSKU: '',
    productCurrency: '',
    revenueDropdown: '',
    actualRevenue: 0,
    productCategory: '',
    productSockets: '',
    productCores: '',
    productNodes: '',
    productSupportType: '',
    productVirtualGuest: '',
    productMeasurement: '',
    quarter: '',
  });

  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [selectedProductHistory, setSelectedProductHistory] = useState([]);

  useEffect(() => {
    if (currentProduct) {
      let dropdownValue = '';
      let revenueValue = 0;

      if (currentProduct.productPrice1M > 0) {
        dropdownValue = 'productPrice1M';
        revenueValue = currentProduct.productPrice1M;
      } else if (currentProduct.productPrice1Y > 0) {
        dropdownValue = 'productPrice1Y';
        revenueValue = currentProduct.productPrice1Y;
      } else if (currentProduct.productPrice3Y > 0) {
        dropdownValue = 'productPrice3Y';
        revenueValue = currentProduct.productPrice3Y;
      }

      setDialogInitialValues({
        name: currentProduct.name || '',
        description: currentProduct.description || '',
        productSKU: currentProduct.productSKU || '',
        productCurrency: currentProduct.productCurrency || '',
        revenueDropdown: dropdownValue,
        actualRevenue: revenueValue,
        productCategory: currentProduct?.productCategory || '',
        productSockets: currentProduct.productSockets || '',
        productCores: currentProduct.productCores || '',
        productNodes: currentProduct.productNodes || '',
        productSupportType: currentProduct.productSupportType || '',
        productVirtualGuest: currentProduct.productVirtualGuest || '',
        productMeasurement: currentProduct.productMeasurement || '',
        quarter: currentProduct.quarter || '',
      });
    } else {
      setDialogInitialValues({
        name: '',
        description: '',
        productSKU: '',
        productCurrency: '',
        revenueDropdown: '',
        actualRevenue: 0,
        productCategory: '',
        productSockets: '',
        productCores: '',
        productNodes: '',
        productSupportType: '',
        productVirtualGuest: '',
        productMeasurement: '',
        quarter: '',
      });
    }
  }, [currentProduct]);

  const fetchProductsDataHandler = useCallback(async () => {
    try {
      // Determine the isActive parameter based on the active tab
      let isActiveParam;
      if (activeTab === 'active') {
        isActiveParam = true;
      } else if (activeTab === 'inactive') {
        isActiveParam = false;
      } else {
        isActiveParam = undefined;
      }

      // Format dates to 'yyyy-mm-dd'
      const formattedFromDate = fromDate
        ? fromDate.toISOString().split('T')[0]
        : undefined;
      const formattedToDate = toDate
        ? toDate.toISOString().split('T')[0]
        : undefined;

      const res = await pimApis.getProductsByCategorya(
        page,
        pageSize,
        categoryId,
        search,
        selectedSort,
        isActiveParam,
        formattedFromDate,
        formattedToDate
      );



      const productDataa = res?.data?.data.map(product => {
        const templateObject = product.productTemplateObject;

        const modifiedObject = Object.entries(templateObject).reduce((acc, [key, value]) => {
          const newKey = key;
          acc[newKey] = value;
          return acc;
        }, {} as Record<string, any>);

        (modifiedObject as Record<string, any>)._id = product._id;
        (modifiedObject as Record<string, any>).isActive = product.isActive;

        return modifiedObject;
      });

      setProductData(productDataa);


      setProductData(productDataa);

      setTotalCount(res?.data?.totalRecords);
    } catch (error) {
      console.error('Error fetching catalog data:', error);
    }
  }, [page, pageSize, search, selectedSort, activeTab, fromDate, toDate]);

  const handlePageSize = (_pageSize: any) => {
    setPageSize(_pageSize);
  };

  const handlePage = (_page: any) => {
    setPage(_page);
  };

  const handleOpenProduct = () => {
    setAddProduct(true);
  };

  const handleCloseProduct = () => {
    setAddProduct(false);
    setEditProduct(false);
    setCurrentProduct(null);
  };

  const handleFileUpload = useCallback(
    async (file: any) => {
      const formData = new FormData();
      formData.append('file', selectedFile ?? file);

      try {
        await pimApis.uploadProductFile(categoryId, formData);
        toast.success('File uploaded successfully');
        setSelectedFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        fetchProductsDataHandler();
      } catch (error) {
        toast.error(error.response?.data?.message || 'File type not supported');
      }
    },
    [fetchProductsDataHandler]
  );

  const debouncedSetSearchTerm = debounce((value) => {
    setSearch(value);
  }, 700);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setActiveTab(newValue);
    setPage(0);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      handleFileUpload(file);
    }
  };

  const { settings } = useSettings();

  const handleSubmitProduct = async (values) => {

    try {
      if (currentProduct) {
        // If editing, update the Product
        await pimApis.updateProduct(currentProduct._id, values);
        toast.success('Product updated successfully');
      } else {
        // If adding, create a new Product
        await pimApis.addProduct(values);
        toast.success('Product added successfully');
      }
      fetchProductsDataHandler(); // Refresh the list
      handleCloseProduct(); // Close the modal after successful submission
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (errorMessage) {
        if (errorMessage === 'Invalid type for field: decimal. Expected: double') {
          toast.error("Please enter a valid decimal number.");
        } else if (errorMessage.includes('Expected: string')) {
          toast.error("Please enter a valid string.");
        } else if (errorMessage.includes('Expected: number')) {
          toast.error("Please enter a valid number.");
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error('Something went wrong');
      }

      console.error('Error creating/updating product:', error);
    }
  };

  const fetchProductHistory = async (productId) => {
    try {
      const historyData = await pimApis.getProductHistory(productId);

      // setSelectedProductHistory(historyData?.data);

      if (historyData?.data) {
        setSelectedProductHistory(historyData.data);
      } else {
        setSelectedProductHistory([]);
      }

    } catch (error) {
      console.log(error.message);
    }
  };

  const handleHistoryClick = async (productId) => {
    await fetchProductHistory(productId); // Fetch the history data
    setHistoryDialogOpen(true);
  };

  const defaultColumns = [
    { id: 'productSKU', label: 'SKU', isSort: true },
    { id: 'name', label: 'Product Name', isSort: true },
    { id: 'productCurrency', label: 'Currency', isSort: true },
    { id: 'productPrice1M', label: 'Monthly MSRP', isSort: true },
    { id: 'productPrice1Y', label: '1 Year MSRP', isSort: true },
    { id: 'productPrice3Y', label: '3 Year MSRP', isSort: true },
    {
      id: 'productCategory',
      label: 'Categories',

      isSort: true,
    },
    { id: 'productSockets', label: 'Sockets', isSort: true },
    { id: 'productCores', label: 'Cores', isSort: true },
    { id: 'productNodes', label: 'Nodes', isSort: true },
    {
      id: 'productSupportType',
      label: 'Support-Type',

      isSort: true,
    },
    {
      id: 'productVirtualGuest',
      label: 'Virtual Guests',
      isSort: true,
    },
    { id: 'productMeasurement', label: 'Unit', isSort: true },
    {
      id: 'isActive',
      label: 'Status',

      Cell: (rowStatus, row: any) => (
        <>        {console.log('aaaaaaaaaaaaaa', rowStatus, row)}
          <Button
            variant="contained"
            className={rowStatus ? classes.activeButton : classes.inActiveButton}
            onClick={async (e) => {
              e.stopPropagation();
              const { _id, isActive } = row;
              try {
                await pimApis.updateProduct(_id, { isActive: !rowStatus });
                toast.success(
                  `Product status updated to ${!rowStatus ? 'Active' : 'In active'
                  }`
                );
                fetchProductsDataHandler();
              } catch (error) {
                toast.error('Error updating status');
                console.error('Error updating Product status:', error);
              }
            }}>
            {rowStatus ? 'Active' : 'In Active'}
          </Button>
        </>
      ),
    },
    {
      id: 'logButton',
      label: 'History',
      Cell: (val, row: any) => {
        const { _id } = row;

        return (
          <HistoryIcon
            onClick={(e) => {
              e.stopPropagation();
              handleHistoryClick(_id);
            }}
          />
        );
      },
    },
  ];

  const handleRowClick = (row) => {
    setCurrentProduct(row);
    setEditProduct(true);
  };


  const currentUrl = window.location.href;

  // const BreadCrumbsData = {
  //   title: currentUrl.includes('settings') ? 'Settings' : 'Categories',
  //   links: currentUrl.includes('settings')
  //     ? []
  //     : [
  //       {
  //         name: 'Catalogues',
  //         to: '/pim/catalogues',
  //       },
  //       {
  //         name: catalogueName || 'Catalogue',
  //         to: `/pim/catalogues/${catalogueId}`,
  //       },
  //     ],
  // };




  const BreadCrumbsData = {
    title: 'Products',
    // links: [
    //   {
    //     name: 'Catalogues',
    //     to: '/pim/catalogues',
    //   },
    //   {
    //     name: catalogueName || `${catalogueId}`,
    //     to: `/pim/catalogues/${catalogueId}`,
    //   },
    //   {
    //     name: categoryName || `${categoryId}`,
    //     to: `/pim/catalogues/${catalogueId}/${categoryId}`,
    //   },
    // ],

    links: currentUrl.includes('settings')
      ? [
        {
          name: 'Settings',
          to: '/pim/settings',
        },
      ]
      : [
        {
          name: 'Catalogues',
          to: '/pim/catalogues',
        },
        {
          name: catalogueName || `${catalogueId}`,
          to: `/pim/catalogues/${catalogueId}`,
        },
        {
          name: categoryName || `${categoryId}`,
          to: ` `,
        },
      ],
  };

  const handleResetFilters = () => {
    if (saerchRef.current) {
      saerchRef.current.value = ""; // Clears the text in the input field
    }
    setSearch(''); // 
    setFromDate(null); // 
    setToDate(null); // 
    setActiveTab('all'); // 
    setPage(0); // 
  };
  const getProductHeader = async (prodTempId) => {
    try {
      const res = await pimApis.getProductHeader(prodTempId);
      setProductFields(res.data.fields)
      const mappedColumns = res.data.fields.map((field) => {
        const fieldId = field.name; // Remove spaces for id

        return {
          id: fieldId,
          label: field.name,
          isSort: true,
        };
      });

      const builtInColumns = [
        {
          id: 'isActive',
          label: 'Status',
          Cell: (rowStatus, row) => (
            <>
              <Button
                variant="contained"
                className={rowStatus ? classes.activeButton : classes.inActiveButton}
                onClick={async (e) => {
                  e.stopPropagation();
                  const { _id, isActive } = row;
                  try {
                    await pimApis.updateProduct(_id, { isActive: !rowStatus });
                    toast.success(
                      `Product status updated to ${!rowStatus ? 'Active' : 'In active'}`
                    );
                    fetchProductsDataHandler();
                  } catch (error) {
                    toast.error('Error updating status');
                    console.error('Error updating Product status:', error);
                  }
                }}
              >
                {rowStatus ? 'Active' : 'In Active'}
              </Button>
            </>
          ),
        },
        {
          id: 'logButton',
          label: 'History',
          Cell: (val, row) => {
            const { _id } = row;
            return (
              <HistoryIcon
                onClick={(e) => {
                  e.stopPropagation();
                  handleHistoryClick(_id);
                }}
              />
            );
          },
        },
      ];


      setCustomColumns([...mappedColumns, ...builtInColumns]);



    } catch (error) {
      console.error('Error fetching catalog data:', error);
    }
  };


  useEffect(() => {
    fetchProductsDataHandler();
    // http://192.168.18.114:8888/product_template/67530864bcefcb62949f6f7f
  }, [fetchProductsDataHandler]);

  const handleCloseUpload = () => {
    setUploadFile(false);

  };

  const handleSubmitUpload = async (file) => {
    setSelectedFile(file[0]);
    handleFileUpload(file[0]);
  }

  const handleOpenUpload = () => {
    setUploadFile(true);

  };

  useEffect(() => {
    if (productTemplateId) {
      getProductHeader(productTemplateId)
    }
  }, [productTemplateId]);

  // productTemplateId


  return (
    <Container
      maxWidth={settings.compact ? 'xl' : false}
      sx={{
        py: 4,
      }}>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          container
          item
          alignItems="center"
          sx={{
            mb: 1,
          }}
          xs={12}>
          <Grid item xs={12} md={5}>
            <SimpleBreadCrumb data={BreadCrumbsData} />
          </Grid>
          <Grid item xs={12} md={7} display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              color="primary"
              // onClick={() => fileInputRef.current?.click()} // Trigger file input click
              onClick={handleOpenUpload}
            >
              Upload File
            </Button>
            <Button
              variant="contained"
              color="secondary"
              title="Add Product"
              sx={{ marginLeft: 1 }}
              onClick={handleOpenProduct}>
              Add Product
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleResetFilters}
              title="Reset to defaults"
              sx={{
                minWidth: '50px',
                p: 0,
                ml: 1,
              }}>
              <RestartAltIcon />
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box
        mt={1}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Box sx={{ display: 'flex' }}>
          <TextField
            inputRef={saerchRef}
            variant="outlined"

            placeholder="Search..."
            onChange={(e) => debouncedSetSearchTerm(e.target.value)}
            InputProps={{
              style: { height: '40px', width: '240px', marginRight: '5px' },
            }}
          />
          {/* <DatePicker
            selected={fromDate}
            onChange={(date) => {
              if (date) {
                const utcDate = new Date(
                  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
                );
                setFromDate(utcDate);
              }
            }}
            placeholderText="From Date"
            dateFormat="yyyy/MM/dd"
            className="date-picker"
            style={{ height: '100%' }}
            customInput={
              <TextField
                variant="outlined"
                autoComplete="off"
                sx={{
                  '& .MuiOutlinedInput-input': {
                    height: '7px',
                  },
                }}
                style={{ height: '40px', width: '240px', marginRight: '5px' }}
              />
            }
          />
          <DatePicker
            selected={toDate}
            onChange={(date) => {
              if (date) {
                const endOfDay = new Date(date);
                endOfDay.setHours(23, 59, 59, 999); // Set to end of the day
                setToDate(endOfDay);
              }
            }}
            placeholderText="To Date"
            dateFormat="yyyy/MM/dd"
            className="date-picker"
            customInput={
              <TextField
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-input': {
                    height: '7px',
                  },
                }}
                style={{ height: '40px', width: '240px' }}
              />
            }
          /> */}
        </Box>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          className={classes.tabs}>
          <Tab label="All" value="all" />
          <Tab label="Active" value="active" />
          <Tab label="Inactive" value="inactive" />
        </Tabs>
      </Box>

      <Box className={classes.productsTable}>
        <CustomListView
          onRowClick={handleRowClick}
          columns={customColumns}
          data={productData || []}
          page={page}
          pageSize={pageSize}
          setPageSize={handlePageSize}
          setPage={handlePage}
          count={totalCount}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
        />
      </Box>
      {/* Add Product Dialog */}
      {/* <ProductDialog
        open={addProduct || editProduct} // Open dialog for both adding and editing
        onClose={handleCloseProduct}
        onSubmit={handleSubmitProduct}
        initialValues={dialogInitialValues} // Use the state for initial values
        title={currentProduct ? 'Edit Product' : 'Add New Product'} // Change title based on context
        isEditMode={!!currentProduct} // Pass isEditMode prop based on currentProduct state
        categoryName={categoryName}
      /> */}
      <FileUpload
        open={uploadFile}
        onClose={handleCloseUpload}
        onSubmitt={handleSubmitUpload}
        // initialValues={cateInitialValues}
        title="Upload your products"
      />

      <ProductDrawer
        productFields={productFields}
        open={addProduct || editProduct}
        onClose={handleCloseProduct}
        onSubmit={handleSubmitProduct}
        initialValues={dialogInitialValues}
        editProduct={editProduct}
        currentProduct={currentProduct}
        title={!editProduct ? 'Add Product' : 'Edit Product'}
      />
      {/* Product History Dialog */}
      <ProductHistoryDialog
        open={historyDialogOpen}
        onClose={() => setHistoryDialogOpen(false)} // Close the history dialog
        historyData={selectedProductHistory} // Pass the history data to the dialog
      />
    </Container>
  );
};

export default CategoriesProduct;
